import { render } from "./release.vue?vue&type=template&id=66cdcafc&scoped=true&ts=true"
import script from "./release.vue?vue&type=script&lang=ts"
export * from "./release.vue?vue&type=script&lang=ts"

import "./release.vue?vue&type=style&index=0&id=66cdcafc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cdcafc"]])

export default __exports__